export default __webpack_public_path__ + "static/media/filterGroups.5364fdce.svg";